import React from 'react'
import { Query } from 'react-apollo'
import { gql } from 'apollo-boost'
import { Flex, Image, Toolbar } from 'rebass'
import { Redirect, withRouter } from 'react-router-dom'
import styled from 'styled-components'

import withAuthorization from './Users/withAuthorization'
import Link from './Link'
import Text from './Text'
import Button from './Button'
import Popover from './Popover'

import logo from '../assets/images/logo.svg'
import routes from '../constants/routes'
import { signOut } from '../firebase/auth'
import media from '../utils/style-utils'

const Trail = Text.extend`
  a { color: ${props => props.theme.colors.text}; }
`

const Navbar = Toolbar.extend`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  color: ${props => props.theme.colors.text};
  box-shadow: ${props => props.theme.shadows[1]};
  
  img {
    height: 40px;
    margin: .5rem .5rem .5rem 0;
  }
`

const Wrap = Flex.extend`
  justify-content: center;
  align-items: center;
`

const Bold = styled.strong`
  display: none;

  ${media.greaterThan('small')`
    display: inline;
  `};
`

const PROFILE_QUERY = gql`
  query CurrentUserForLayout {
    me {
      emailAddress
    }
  }
`

const onSignOut = async client => {
  await signOut()
  client.resetStore()
}

const Separator = () =>
  <Text is='span' mx={2}>/</Text>

const Navigation = ({uid, location: {pathname}}) => {
  const trail1 = pathname.includes(routes.USERS) ? <Link to={routes.USERS}>Users</Link>
    : pathname.includes(routes.BEACONS) ? <Link to={routes.BEACONS}>Beacons</Link>
      : pathname.includes(routes.MANUFACTURERS) ? <Link to={routes.MANUFACTURERS}>Manufacturers</Link>
        : pathname.includes(routes.MODELS) ? <Link to={routes.MODELS}>Models</Link>
          : pathname.includes(routes.TEMPLATES) ? <Link to={routes.TEMPLATES}>Templates</Link>
            : pathname.includes(routes.PAGES) ? <Link to={routes.PAGES}>Pages</Link>
              : ''

  const trail2 = pathname.includes(routes.NEW_USER) ? <Link to={routes.NEW_USER}>New</Link>
    : pathname.includes(routes.NEW_BEACON) ? <Link to={routes.NEW_BEACON}>New</Link>
      : pathname.includes(routes.NEW_MANUFACTURER) ? <Link to={routes.NEW_MANUFACTURER}>New</Link>
        : pathname.includes(routes.NEW_MODEL) ? <Link to={routes.NEW_MODEL}>New</Link>
          : pathname.includes(routes.NEW_TEMPLATE) ? <Link to={routes.NEW_TEMPLATE}>New</Link>
            : pathname.includes(routes.NEW_PAGE) ? <Link to={routes.NEW_PAGE}>New</Link>
              : ''

  return uid
    ? (
      <React.Fragment>
        <Navbar>
          <Wrap><Image src={logo} /><Text><Bold>Dot Dot Data&nbsp;</Bold>Admin</Text></Wrap>
          <Query query={PROFILE_QUERY} fetchPolicy='cache-and-network'>
            {({client, data}) =>
              <Popover
                trigger={<Text>{data && data.me && data.me.emailAddress}</Text>}
                content={<Button onClick={() => onSignOut(client)}>Sign Out</Button>}
              />
            }
          </Query>
        </Navbar>
        {trail1 && !trail2 && <Trail p={2} mb={3}><Link to='/'>Home</Link><Separator />{trail1}</Trail>}
        {trail1 && trail2 && <Trail p={2} mb={3}><Link to='/'>Home</Link><Separator />{trail1}<Separator />{trail2}</Trail>}
      </React.Fragment>
    )
    : pathname === routes.LOGIN ? null : <Redirect to={routes.LOGIN} />
}

export default withAuthorization()(withRouter(Navigation))


// WEBPACK FOOTER //
// ./src/components/Navigation.js